import { CycleCalendar } from "@/components/shared/cycle-calendar"

type PreferenceCalendarProps<TExtendedProps extends Record<string, unknown>> =
  Omit<
    React.ComponentProps<typeof CycleCalendar<TExtendedProps>>,
    "eventDidMount" | "interactive"
  >

export function PreferenceCalendar<
  TExtendedProps extends Record<string, unknown>,
>(props: PreferenceCalendarProps<TExtendedProps>) {
  return (
    <CycleCalendar
      {...props}
      interactive={false}
      eventDidMount={({ el, event }) => {
        if (event.extendedProps.preferenceHighlighted) {
          el.classList.add("scale-110", "z-index-100!")
        }

        if (event.extendedProps.priorityHighlighted) {
          el.classList.add("ring-2!", "ring-primary!", "ring-offset-2!")
        }

        if (event.extendedProps.priorityConflicts) {
          el.classList.add(
            "ring-2!",
            "ring-destructive!",
            "ring-offset-2!",
            "z-index-100!",
          )
        }

        if (event.extendedProps.preferenceInvalid) {
          el.classList.add(
            "ring-2!",
            "ring-destructive!",
            "ring-offset-2!",
            "z-index-100!",
          )
        }
      }}
    />
  )
}
